var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-861.000000, -1331.000000)",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(861.000000, 1331.000000)",
    stroke: "#263238"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: -0.727922061,
    x2: 12,
    y2: 24.7279221,
    id: "Line-3",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.727922061,
    y1: 12,
    x2: 24.7279221,
    y2: 12,
    id: "Line-3",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.25fce53c.svg";
export { ForwardRef as ReactComponent };